export default __webpack_public_path__ + "static/title-about_pc-4bf463748928e44bd5505f858ddfd504.png";